<template>
  <v-list dense nav>
    <!--  -->

    <template v-for="item in menuList">
      <template v-if="item.children && !mini">
        <v-list-group
          :key="item.id"
          :value="item.active"
          :prepend-icon="item.icon"
          no-action
        >
          <template #activator>
            <v-list-item-content>
              <v-list-item-title
                class="font-weight-regular"
                v-text="item.label"
              />
            </v-list-item-content>
          </template>

          <template v-for="item2 in item.children">
            <v-list-item
              :key="item2.id"
              :to="item2.route"
              :disabled="item2.disabled"
              link
            >
              <!--
              <v-list-item-icon>
                <v-icon>{{ item2.icon }}</v-icon>
              </v-list-item-icon>
              -->

              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-regular"
                  v-text="item2.label"
                />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>

      <template v-else-if="!item.children">
        <v-tooltip :key="item.id" :disabled="!mini" right>
          <template #activator="{ on }">
            <v-list-item
              :to="item.route"
              :disabled="item.disabled"
              link
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-regular"
                  style="white-space: unset;"
                  v-text="item.label"
                />
              </v-list-item-content>
            </v-list-item>
          </template>
          <span v-text="item.label" />
        </v-tooltip>
      </template>

      <template v-else>
        <v-menu
          :key="item.id"
          open-on-hover
          close-on-content-click
          offset-x
        >
          <template #activator="{ on, attrs }">
            <v-list-item
              v-bind="attrs"
              :class="{ 'v-list-item--active': item.active }"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-regular"
                  style="white-space: unset;"
                  v-text="item.label"
                />
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list dense>
            <template v-for="item2 in item.children">
              <v-list-item
                :key="item2.id"
                :to="item2.route"
                :disabled="item2.disabled"
                link
              >
                <v-list-item-icon v-if="item2.icon">
                  <v-icon>{{ item2.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-regular"
                    v-text="item2.label"
                  />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </template>

    <!--  -->
  </v-list>
</template>

<script>
export default {
  name: 'BMenuList',
  props: {
    mini: Boolean,
    selectedMenuSystem: {
      type: Object,
      required: true,
    },
    menuList: {
      type: Array,
      required: true,
    },
  },
}
</script>
